import React from 'react'
import imgtalkz from '../img/portImages/chat.png'
import imgtalkz2 from '../img/portImages/chat2.png'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { RiShareBoxLine } from 'react-icons/ri'

const Talkz = () => {
    return (
        <Style>
            <Title>Talkz</Title>
            <Desc>Talkz APP made by an rest API called ChatEngine. You can use this app for chating in any condition,
                this app also design with attractive menu and also mobile responsive.
            </Desc>
            <Text>
                <StackList>
                    <Stack>Website : <Link to={{ pathname: "https://talkzapp.netlify.app/" }} target="_blank"><span>https://talkzapp.netlify.app/ <RiShareBoxLine/></span></Link></Stack>
                    <Stack>GitHub : <Link to={{ pathname: "https://github.com/dhikad19/talkz-app" }} target="_blank"><span>https://github.com/dhikad19/talkz-app <RiShareBoxLine/></span></Link></Stack>
                    <Stack1>Stack : <span>React</span> <span>JavaScript</span> <span>HTML</span> <span>CSS</span> <span>API</span></Stack1>
                </StackList>
            </Text>
            <ImageContainer>
            <Image src={imgtalkz} />
            <Image src={imgtalkz2} />
            </ImageContainer>
        </Style>
    )
}

const ImageContainer = styled.div`
    max-width: 600px;
`
const Style = styled.section`
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
    display : grid;
`
const Title = styled.h1`
    text-align: left;
    display : flex;
    font-size: 40px;
    color: #c46500;

    @media screen and (max-width: 768px){
        font-size: 25px;
        padding: 0 1rem;
    }
`
const Desc = styled.p`
    max-width: 600px;
    font-size: 18px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    @media screen and (max-width: 768px){
        font-size: 15px;
        padding: 0 1rem;
    }
`
const Text = styled.div`
    margin-bottom: 0.7rem;
`
const StackList = styled.ul`
    margin-bottom: 1.5rem;
`
const Stack = styled.li`
    font-size: 18px;
    margin-top: 10px;
    @media screen and (max-width: 768px){
        font-size: 15px;
        padding: 0 1rem;
    }
    span{
        color: #c46500;
        font-size: 18px;
        

        &:hover{
            text-decoration: underline;
        }
        @media screen and (max-width: 768px){
        font-size: 15px;
    }
    }
`
const Stack1 = styled.li`
    font-size: 18px;
    margin-top: 10px;
    @media screen and (max-width: 768px){
        font-size: 15px;
        padding: 0 1rem;
    }
    span{
        background: #c46500;
        color: #000;
        font-size: 18px;
        border-radius: 5px;
        margin: 1px;
        @media screen and (max-width: 768px){
        font-size: 15px;
    }
    }
`
const Image = styled.img`
    width: 100%;
    height: 40vh;
    object-fit: cover;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    @media screen and (max-width: 768px){
        padding: 0 1rem;
        height: 30vh;
    }
`
export default Talkz
